module.exports = __webpack_public_path__ + "img/Live Tag.24e85fe1.svg";